module.exports = __webpack_public_path__ + "assets/logo_contexte.a0e01e87.svg";